module.exports = __webpack_public_path__ + "static/media/92.a712e70f.jpg";